/*@ngInject*/
const RowRepeaterController = function ($rootScope, $scope, $timeout, localization, formComponentUtil, fieldType, formMediator, modalUtil, xmlUtil, formViewerConstant, rowRepeaterUtil, rowRepeaterRowListComparisonResultConstant) {

    let translations;
    const timeoutList = [];

    this.$onInit = function () {
        localization.getTranslations().then((result) => {
            translations = result;
            this.addButtonTooltip = translations.formsViewer.rowRepeater.addButtonTooltip;
            this.trashIconTooltip = translations.formsViewer.rowRepeater.trashIconTooltip;
        });

        this.fieldType = fieldType;
        this.rowsToDelete = [];
        this.visibleRowList = [];
        this.fieldList = [];
        this.previousRowList = [];

        this.repeaterFieldStructure = this.row.repeaterFieldStructure;
        this.rowRepeaterTitle = '';
        this.rowRepeaterTitleClass = null;

        this.hasRowAdditionInProgress = false;
        this.isDeleting = false;
        this.isDeleteAllSelected = false;
        this.isDeletable = false;
        this.isSubmitDeleteEnabled = false;
        this.showLoadingSpinner = false;
        this.showRepeater = true;

        this.rowNumberField = _.clone(this.row.rowTemplate.fields[0]);
        this.rowNumberField.displayLabel = '#';
        this.rowNumberField.inputWidth = 20;
        this.rowNumberField.labelWidth = 20;
        this.rowNumberField.minWidth = 20;
        this.rowNumberField.fieldTemplate = {
            variableName: 'rowNumber',
            type: fieldType.TEXT_INPUT
        };
        this.rowNumberField.hidden = !xmlUtil.parseString(this.row.rowTemplate.repeaterField.options).showRowNumber;

        this.init();

        $scope.$on(formViewerConstant.event.CREATE_ROW, () => {
            timeoutList.push($timeout(() => {
                this.hasRowAdditionInProgress = false;
            }, 100));
        });

        $scope.$on(formViewerConstant.event.REPEATING_ROW_SELECTED, (event, triggerEvent, row) => {
            if (this.isDeleting && !row.isRowDeleteDisabled && row.rowTemplate.id === this.row.rowTemplate.id) {
                this.onSelectRow(triggerEvent, row);
            }
        });

        $scope.$on(formViewerConstant.configuration.event.DELETE_FIELD, () => {
            this.refresh();
        });

        $scope.$on(formViewerConstant.configuration.event.FIELD_MOVED_IN_ROW, () => {
            this.refresh();
        });

        $scope.$on(formViewerConstant.configuration.event.UPDATE_COMPONENT_SETTING, () => {
            this.refresh();
        });

        $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, () => {
            this.refresh();
        });

        $scope.$watch('$ctrl.row.timeLastModified', () => {
            const sortChanged = !_.isNil(this.sort) && (this.sort.sortKey !== this.row.sort.sortKey || this.sort.sortType !== this.row.sort.sortType);
            const rowRepeaterRowListComparisonResult = rowRepeaterUtil.compareRowLists(this.row.rowList, this.previousRowList);
            const rowRepeaterRowListComparisonWarrantsChange = rowRepeaterRowListComparisonResult !== rowRepeaterRowListComparisonResultConstant.EQUAL && rowRepeaterRowListComparisonResult !== rowRepeaterRowListComparisonResultConstant.ONE_ROW_ADDED;

            if (sortChanged || rowRepeaterRowListComparisonWarrantsChange) {
                this.onChange(this.startIndexOrig, this.endIndexOrig);
            }

            this.previousRowList = _.cloneDeep(this.row.rowList);
        });

        this.processCollapsibleColumnsAndVisibility();
    };

    this.init = function () {
        this.showRepeater = this.isRepeaterVisible();
        this.previousRowList = _.cloneDeep(this.row.rowList);

        this.fieldList = _.filter(this.row.rowTemplate.fields, (uiField) => {
            const isRowRepeater = uiField.fieldTemplate.type === fieldType.ROWREPEATER;

            if (isRowRepeater) {
                this.rowRepeaterTitle = uiField.displayLabel;
            }
            return !isRowRepeater;
        });


        this.allColumnsWithNoLabel = this.isAllColumnsWithNoLabel();

        const isLabelBold = _.toLower(this.repeaterFieldStructure.uiField.labelFontStyle) !== 'normal';
        if (isLabelBold) {
            this.rowRepeaterTitleClass = 'isBold';
        }

        if (this.row.pageSize <= 0) {
            this.row.pageSize = Number.MAX_SAFE_INTEGER;
        }
    };

    this.isAllColumnsWithNoLabel = function () {
        let allColumnsWithNoLabel = true;
        _.each(this.row.rowList, function (item) {
            _.each(item.fieldStructureList, function (fieldStructure) {
                const fieldInstance = fieldStructure.fieldModel,
                    fieldTemplate = fieldStructure.uiField.fieldTemplate;
                if (fieldTemplate.type !== fieldType.ROWREPEATER && ((!formComponentUtil.isFieldHidden(fieldInstance, fieldTemplate)
                    && fieldStructure.dynamicProperties.isRequired) || !_.isEmpty(fieldStructure.uiField.displayLabel))) {
                    allColumnsWithNoLabel = false;
                    return false;
                }
            });
        });
        return allColumnsWithNoLabel;
    };

    this.isRepeaterVisible = function () {
        let isVisible = this.configurable;
        if (!isVisible) {
            _.each(this.row.rowList, function (item) {
                _.each(item.fieldStructureList, function (fieldStructure) {
                    const fieldInstance = fieldStructure.fieldModel,
                        fieldTemplate = fieldStructure.uiField.fieldTemplate;
                    if (!formComponentUtil.isFieldHidden(fieldInstance, fieldTemplate)) {
                        isVisible = true;
                        return false;
                    }
                });
                if (isVisible) {
                    return false;
                }
            });
        }
        return isVisible;
    };

    this.updateSelectedRows = function () {
        this.rowsToDelete = _.filter(this.row.rowList, function (row) {
            return row.selected === true;
        });

        this.updateSubmitDeleteButton();
        this.isDeleteAllSelected = false;
    };

    this.onAddRow = function () {
        const formId = this.row.parentForm.id,
            rowId = this.row.rowTemplate.id,
            rowNumberOfLastRow = this.row.rowList.length;

        if (!this.hasRowAdditionInProgress) {
            this.hasRowAdditionInProgress = true;

            formMediator.addRepeatingRow(formId, rowId, rowNumberOfLastRow);
        }
    };

    this.onInitializeDelete = function () {
        _.each(this.row.rowList, item => {
            item.isRowDeleteDisabled = this.isRowDeleteDisabled(item);
            item.isDeleting = true;
        });
        this.isDeleting = true;
        this.isDeleteAllSelected = false;
        this.updateSubmitDeleteButton();
        this.bulkUpdateHeight = 32;
    };

    this.onChange = function (startIndex, endIndex) {
        this.startIndexOrig = startIndex;
        this.endIndexOrig = endIndex;
        this.sort = this.row.sort;
        this.showLoadingSpinner = true;

        timeoutList.push($timeout(() => {
            const sortedList = this.row.rowList;

            this.visibleRowList = [];
            this.isDeleteAllSelected = false;

            if (this.row.pageSize > 0 && !this.row.parentForm.printPreview) {
                _.each(sortedList, (item, index) => {
                    if (index >= startIndex && index <= endIndex) {
                        this.visibleRowList.push(item);
                    }
                });
            } else {
                _.each(sortedList, (item) => {
                    this.visibleRowList.push(item);
                });
            }

            timeoutList.push($timeout(() => {
                this.showLoadingSpinner = false;
                $rootScope.$broadcast(formViewerConstant.event.REPEATING_ROW_PAGE_CHANGE);
            }, this.visibleRowList.length * 50));
        }, 0));
    };

    this.processCollapsibleColumnsAndVisibility = function () {
        formMediator.processCollapsibleColumnsAndVisibility(this.row.rowRepeaterId, this.rootFormId);
    };

    this.isRowDeleteDisabled = function (row) {
        const form = row.parentForm,
            fieldStructure = _.find(row.fieldStructureList, function (item) {
                return item.uiField.fieldTemplate.type === fieldType.ROWREPEATER;
            }),
            fieldInstance = fieldStructure.fieldModel || {},
            fieldTemplate = fieldStructure.uiField.fieldTemplate,
            hasWriteAccess = form.hasWriteAccess,
            hasAllActionsDisabled = fieldInstance.value === 'o',
            isAddOnly = fieldInstance.value === '+';

        if (!this.row.rowList.length) {
            return true;
        }

        return hasAllActionsDisabled || isAddOnly || formComponentUtil.isFieldDisabled(form, fieldInstance, fieldTemplate, hasWriteAccess);
    };

    this.isRowRepeaterAddDisabled = function () {
        let result = false;
        const form = this.row.parentForm;

        if (!form.hasWriteAccess) {
            result = true;
        } else if (form.hasWriteAccess) {
            const lastRowInstanceIndex = this.row.rowList.length - 1,
                lastRowInstance = this.row.rowList[lastRowInstanceIndex];
            if (!_.isNil(lastRowInstance)) {
                const rowRepeaterFieldTemplate = this.row.rowTemplate.repeaterField.fieldTemplate,
                    isRowRepeaterFieldDisabled = formComponentUtil.isFieldDisabled(form, null, rowRepeaterFieldTemplate, form.hasWriteAccess),
                    lastRowRepeaterField = _.find(lastRowInstance.fieldStructureList, function (item) {
                        return item.uiField.fieldTemplate.type === fieldType.ROWREPEATER;
                    }),
                    lastRowRepeaterFieldInstance = lastRowRepeaterField.fieldModel || {},
                    hasAllActionsDisabled = lastRowRepeaterFieldInstance.value === 'o',
                    isDeleteOnly = lastRowRepeaterFieldInstance.value === '-',
                    isLastRowRepeaterFieldInstanceDisabled = formComponentUtil.isFieldDisabled(form, lastRowRepeaterFieldInstance, rowRepeaterFieldTemplate, form.hasWriteAccess);

                result = hasAllActionsDisabled || isDeleteOnly || isRowRepeaterFieldDisabled || isLastRowRepeaterFieldInstanceDisabled;
            }
        }

        return result;
    };

    this.isRepeaterDeleteDisabled = function () {
        let result = false;
        const form = this.row.parentForm;

        if (!form.hasWriteAccess) {
            result = true;
        } else if (form.hasWriteAccess) {
            const disabledRowList = _.filter(this.row.rowList, (row) => {
                    return this.isRowDeleteDisabled(row);
                }),
                totalRows = this.row.rowList.length,
                rowsAvailableForDelete = totalRows - disabledRowList.length;

            result = totalRows < 2 || rowsAvailableForDelete === 0;
        }

        return result;
    };

    this.updateSubmitDeleteButton = function () {
        this.isSubmitDeleteEnabled = this.rowsToDelete.length !== 0;
        this.isSubmitDeleteEnabled = this.isSubmitDeleteEnabled && this.rowsToDelete.length !== this.row.rowList.length;
    };

    this.onDeleteAllClick = function () {
        _.map(this.visibleRowList, (row) => {
            if (!this.isRowDeleteDisabled(row)) {
                row.selected = this.isDeleteAllSelected;
            }
            return row;
        });

        this.rowsToDelete = _.filter(this.row.rowList, function (item) {
            return item.selected === true;
        });

        this.updateSubmitDeleteButton();
    };

    this.onCancelDelete = function () {
        _.each(this.row.rowList, function (item) {
            item.selected = false;
            item.isDeleting = false;
        });
        this.isDeleting = false;
        this.rowsToDelete = [];
        this.bulkUpdateHeight = 0;
    };

    this.onConfirmDelete = function () {
        const config = {
            cancelButtonLabel: translations.formsViewer.rowRepeater.cancel,
            confirmActionButtonLabel: translations.formsViewer.rowRepeater.confirm,
            summary: translations.formsViewer.rowRepeater.deleteConfirmationMessage,
            title: translations.formsViewer.rowRepeater.deleteConfirmationTitle
        };

        config.summary = config.summary.replace('{1}', this.rowsToDelete.length);
        config.summary = config.summary.replace('{2}', this.rowsToDelete.length > 1 ? 's' : '');

        modalUtil.showGenericConfirm(config).then(() => {
            const rowIds = [];

            this.showLoadingSpinner = true;

            _.filter(this.row.rowList, function (row) {
                return row.selected === true;
            }).map(function (row) {
                return rowIds.push(row.rowModel.id);
            });

            formMediator.deleteRepeatingRow(rowIds).then(() => {
                this.onCancelDelete();

                timeoutList.push($timeout(() => {
                    this.showLoadingSpinner = false;
                }, 1500));
            });
        });
    };

    this.onSelectRow = function (event, row) {
        _.each(this.row.rowList, function (rowElement) {
            if (row.rowModel.id === rowElement.rowModel.id) {
                rowElement.selected = !rowElement.selected;
                return false;
            }
        });
        this.updateSelectedRows();
    };

    this.refresh = function () {
        timeoutList.push($timeout(() => {
            this.init();
            this.row.timeLastModified = new Date().getTime();
        }), 0);
    };

    this.rowRepeaterClicked = function () {
        $rootScope.$broadcast(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, this.row);
    };

    this.$onDestroy = function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    };
};

angular.module('umFormViewer')
    .controller('rowRepeaterController', RowRepeaterController);
